var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenIssues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1907 9.252C10.4773 8.8736 10.6538 8.40775 10.6538 7.89744V7.69231H13.3205V6.46154H10.6538V6.25641C10.6538 5.01202 9.64183 4 8.39744 4H6.75641C5.51202 4 4.5 5.01202 4.5 6.25641V7.89744C4.5 9.14183 5.51202 10.1538 6.75641 10.1538H8.39744C8.6842 10.1538 8.95623 10.0948 9.20878 9.99684L12.5033 13.9504C12.7759 13.6394 13.1036 13.3836 13.4748 13.1931L10.1907 9.252ZM9.42308 7.89744C9.42308 8.46314 8.96314 8.92308 8.39744 8.92308H6.75641C6.19071 8.92308 5.73077 8.46314 5.73077 7.89744V6.25641C5.73077 5.69071 6.19071 5.23077 6.75641 5.23077H8.39744C8.96314 5.23077 9.42308 5.69071 9.42308 6.25641V7.89744Z",
    fill: "#172B4D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 4.6,
    width: 4.8,
    height: 4.8,
    rx: 1.4,
    fill: "white",
    stroke: "#6929E2",
    strokeWidth: 1.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.6,
    y: 14.6,
    width: 4.8,
    height: 4.8,
    rx: 1.4,
    fill: "white",
    stroke: "#6929E2",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIssues);
export default __webpack_public_path__ + "static/media/openIssues.12874673eea47b662d91b32475120b51.svg";
export { ForwardRef as ReactComponent };